import { Link as JoyLink } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { Link as RouterLink } from 'react-router-dom';

import { partFinderFamilyPath } from 'companySettings/routes';
import { IPartFinderFamily } from 'companySettings/types';
import { Link } from 'core/elements';
import { Level } from 'theme/enums';

import { UpsertPartFinderFamilyButton } from '../UpsertPartFinderFamily';
import { opensInWizard } from '../utils';

// The id opens the family: a draft still being set up in the wizard, filled in, as the design draws
// it; any other in its editor.
export const IdCell = ({ data }: ICellRendererParams<IPartFinderFamily>) => {
  if (!data) {
    return null;
  }

  if (!opensInWizard(data)) {
    return (
      <JoyLink
        component={RouterLink}
        to={partFinderFamilyPath(data.id)}
        level={Level.TITLE_SM}
        sx={{ fontWeight: 'bold' }}
      >
        {data.id}
      </JoyLink>
    );
  }

  return (
    <UpsertPartFinderFamilyButton
      family={data}
      buttonElement={
        <Link component="button" level={Level.TITLE_SM} sx={{ fontWeight: 'bold' }}>
          {data.id}
        </Link>
      }
    />
  );
};
